<dashboard-dialog-frame header="Filters" [actions]="actions()" icon="fa-filter" alertType='editor' [dialogRef]="dialogRef">

	<kendo-filter [value]=" originalFilters()" (valueChange)="onFiltersChange($event)" class="p-2">

		@for(exp of filterExpressions(); track exp){
		<kendo-filter-field [field]="exp.field" [title]="exp.title ||''" [editor]="exp.editor"></kendo-filter-field>
		}
	</kendo-filter>

</dashboard-dialog-frame>